import React from 'react';
import { Chip, Typography } from '@mui/material';

interface SystemGeneratedRaidIndicatorProps {
  isSystemGenerated?: boolean;
  variant?: 'chip' | 'label';
}

const SystemGeneratedRaidIndicator: React.FC<SystemGeneratedRaidIndicatorProps> = ({
  isSystemGenerated = false,
  variant = 'chip',
}) => {
  if (variant === 'label') {
    return (
      <Typography variant="body2" color={isSystemGenerated ? 'info.main' : 'text.secondary'}>
        {isSystemGenerated ? 'Yes' : 'No'}
      </Typography>
    );
  }

  if (!isSystemGenerated) {
    return (
      <Typography variant="body2" color="text.secondary">
        No
      </Typography>
    );
  }

  return <Chip label="System Generated" size="small" color="info" variant="outlined" />;
};

export default SystemGeneratedRaidIndicator;
